export var EExchangeType;
(function (EExchangeType) {
    EExchangeType["NSE"] = "NSE";
    EExchangeType["BSE"] = "BSE";
})(EExchangeType || (EExchangeType = {}));
export var ECommodityExchangeType;
(function (ECommodityExchangeType) {
    ECommodityExchangeType["MCX"] = "MCX";
    ECommodityExchangeType["NCDEX"] = "NCDEX";
})(ECommodityExchangeType || (ECommodityExchangeType = {}));
export var EGLType;
(function (EGLType) {
    EGLType["GAIN"] = "gain";
    EGLType["LOSS"] = "loss";
})(EGLType || (EGLType = {}));
export var EPeriod;
(function (EPeriod) {
    EPeriod["ONE_DAY"] = "1D";
    EPeriod["ONE_WEEK"] = "1WK";
    EPeriod["ONE_MONTH"] = "1MN";
    EPeriod["THREE_MONTH"] = "3MN";
    EPeriod["SIX_MONTH"] = "6MN";
    EPeriod["ONE_YEAR"] = "1YR";
})(EPeriod || (EPeriod = {}));
export var EPricePeriod;
(function (EPricePeriod) {
    EPricePeriod["THREE_DAY"] = "3D";
    EPricePeriod["FIVE_DAY"] = "5D";
    EPricePeriod["SEVEN_DAY"] = "7D";
    EPricePeriod["FOURTEEN_DAY"] = "14D";
})(EPricePeriod || (EPricePeriod = {}));
export var EVolumePeriod;
(function (EVolumePeriod) {
    EVolumePeriod["TODAY"] = "FTD";
    EVolumePeriod["THIS_WEEK"] = "WTD";
    EVolumePeriod["THIS_MONTH"] = "MTD";
    EVolumePeriod["THIS_YEAR"] = "YTD";
})(EVolumePeriod || (EVolumePeriod = {}));
export var ECircuitFilter;
(function (ECircuitFilter) {
    ECircuitFilter["TWO_PERCENT"] = "2";
    ECircuitFilter["FIVE_PERCENT"] = "5";
    ECircuitFilter["TEN_PERCENT"] = "10";
    ECircuitFilter["TWENTY_PERCENT"] = "20";
    ECircuitFilter["NO_FILTER"] = "NCF";
})(ECircuitFilter || (ECircuitFilter = {}));
